export enum QueryKey {
  VVS_MOLE_IS_SALE_ACTIVE = 'mole-contract:sale-active',
  VVS_MOLE_CURRENT_SALE_PHASE = 'mole-contract:sale-phase',
  VVS_MOLE_USER_TOKENS = 'mole-contract:user-minted-tokens',
  VVS_MOLE_USER_TOKEN_LENGTH = 'mole-contract:user-minted-token-length',
  TOKEN_BALANCE_QUERY = 'token-balance-query',
  IS_CHAIN_CORRECT = 'is-chain-correct',
  BALANCE_OF_USER = 'balance-of-user',
  TOKEN_OF_USER_BY_INDEX = 'token-of-user-by-index',
  VVS_INFO_API_META_MOLE_LIST = 'vvs_info_api_meta_mole_list',
  VVS_MOLE_APPROVAL_FOR_ALL = 'mole-contract:approval-for-all',
  VVS_MOLE_APPROVAL_IS_FOR_ALL = 'mole-contract:is-approval-for-all',
  FARM_TOTAL_SIZE = 'farm-total-size',
  VVS_MOLE_TOKENS_OF_USER = 'mole-tokens-of-user',
  FARM_BOOSTED_USER_INFOS = 'farm-boosted-user-infos',
  MY_MOLE_META_DETAILS = 'my-mole-meta-details',

  FARM_BOOST_CALCULATE_TOTAL_MULTIPLIER = 'farm-boost:calculateTotalMultiplier',
  GET_BOOSTED_FARMS = 'farm-boost:getBoostedFarms',
  WITHDRAW_BOOST_REWARD = 'farm-boost:withdrawBoostReward',
  HARVEST_BOOST = 'farm-boost:harvestBoost',
  HARVEST_BOOST_BY_PID = 'farm-boost:harvestBoostByPid',
  REMOVE_BOOST_AND_UNSTAKED_NFTS = 'farm-boost:removeBoostAndUnstakeNfts',
  STAKE_NFTS_AND_BOOST_FARM = 'farm-boost:stakeNftsAndBoostFarm',
  GET_USER_SHARE = 'farm-boost:getUserShare',
  GET_TOTAL_SHARE = 'farm-boost:getTotalShare',
  GET_ACTUAL_ADJUST_SHARE = 'farm-boost:getActualAdjustedShare',
  GET_POTENTIAL_ADJUST_SHARE = 'farm-boost:getPotentialAdjustShare',
  FARM_BOOST_POOL_INFO = 'farm-boost:getPoolInfo',
  FARM_BOOST_USER_INFO = 'farm-boost:getUserInfo',
  FARM_BOOST_UPDATE_SHARES = 'farm-boost:updateShares',

  // craftsman
  CRAFTSMAN_USER_INFO = 'craftsman:userInfo',
  CRAFTSMAN_POOL_INFO = 'craftsman:poolInfo',
  CRAFTSMAN_VVS_PER_BLOCK = 'craftsman:vvsPerBlock',
  CRAFTSMAN_TOTAL_ALLOC_POINT = 'craftsman:totalAllocPoint',

  // vvsBoost
  VVS_BOOST_POOL_INFO = 'vvsBoost:poolInfo',
  VVS_BOOST_BALANCE_OF_INFO = 'vvsBoost:balanceOf',

  // rarity Registry
  RARITY_REGISTRY_GET_RARITY_LEVEL = 'rarityRegistry:getRarityLevel',

  // complex queries
  BOOSTED_FARM_USERINFOS = 'boostedFarmUserinfos',
  MY_MOLE_IDS_WITH_STAKED = 'myMoleIdsWithStaked',

  // rewarderV2
  REWARDER_V2_GET_BOOST_FACTOR = 'rewarderV2:viewBoostFactor',
  REWARDER_V2_VIEW_POOL_INFO = 'rewarderV2:viewPoolInfo',
  REWARDER_V2_VIEW_USER_INFO = 'rewarderV2:getUserInfo',
  REWARDER_V2_ARGO_APPROVAL_IS_FOR_ALL = 'rewarderV2:argo-is-approval-for-all',
  VVS_INFO_API_META_USER_NFT_COLLECTIONS = 'vvs_info_api_meta_user_nft_collections',

  // vvsgotchi
  VVS_GOTCHI_OWNER = 'vvsgotchi-owner',
  VVS_GOTCHI_QUESTS = 'vvsgotchi-quests',
}
